import { OrderPlanningRowAction, ReasonMap } from "./OrderPlanningRowAction";
import { Button, TableRow } from "@mcleod/components";
import { PlanningTableRowActionProps } from "@mcleod/general/src/planning/PlanningTableRowAction";
import { FeasibilitySlideout } from "../../asset/FeasibilitySlideout";
import { OrderPlanningToolPanel, Tools } from "../OrderPlanningToolPanel";
import { ModelRow } from "@mcleod/core";

export class RowActionFeasibility extends OrderPlanningRowAction {
    public skipSyncUpdate: boolean = false;

    override getButton(): Button {
        return this.toolPanel.buttonFeasibility;
    }

    override getButtonId(): string {
        return "buttonFeasibility";
    }

    override onLayoutLoad(): void {
        if (this.toolPanel.isForEquipMoves()) {
            const equipName = "Preplan Feasibility";
            this.getButton().caption = equipName;
            this.getButton().tooltip = equipName;
        }
    }

    override deselectionAllowed(): boolean {
        return true;
    }

    override getFieldsUsedInThisFile(): string[] {
        return ["driver1_preassign_count", "tractor", "tractor_active", "driver1_id", "driver1_active", "movement_id"];
    }

    override actionValidateSelection(selectedRows: ModelRow[], reasonMap: ReasonMap): void {
        let modelRow: ModelRow;
        if (selectedRows && selectedRows.length > 0) {
            modelRow = selectedRows[0];
            if (modelRow != null && modelRow instanceof TableRow) {
                modelRow = (modelRow as TableRow).data;
            }
        }

        const isForOrderMoves = this.toolPanel.isForOrderMoves();
        const isForEquipMoves = this.toolPanel.isForEquipMoves();
        const splitView = this.toolPanel.splitViewLayout;
        const ordersModelRow = isForOrderMoves && modelRow ? modelRow : splitView ? splitView.layoutOrderPlanningOrders.tableAvailableMoves.selectedRow?.data : null;
        const equipModelRow = isForEquipMoves && modelRow ? modelRow : splitView ? splitView.getActiveEquipLayout().getTable()?.selectedRow?.data : this.toolPanel.table.selectedRow?.data ?? null;
        const isPreassigned = this.toolPanel.table.id === "tableEquipMoves" || (!ordersModelRow?.isNull("driver1_id") && !ordersModelRow?.isNull("tractor"));
        const secondarySelected = (isForOrderMoves && this.toolPanel.splitViewLayout) ?
            this.toolPanel.splitViewLayout.getActiveEquipLayout()["getTable"]()?.selectedRow != null : false;

        if (isForOrderMoves && ordersModelRow) {
            if (!isPreassigned && !secondarySelected) {
                this.addReason(reasonMap, "no_preassignment", "Select a preassigned order, or an order and a tractor, to check feasibility.");
            } else if (secondarySelected && equipModelRow?.get("driver1_preassign_count") > 0) {
                this.addReason(reasonMap, "preassigned_driver", "Feasibility cannot be calculated for a driver who already has preassignments.");
            }
        } else if (isForEquipMoves && equipModelRow?.get("driver1_preassign_count") == 0) {
            this.addReason(reasonMap, "no_preassignment", "Feasibility cannot be calculated for a driver with no preassignments.");
        } else if (isForOrderMoves && ordersModelRow == null || isForEquipMoves && equipModelRow == null) {
            this.addReason(reasonMap, "no_order_or_equip", "No valid order or equipment row selected.");
        } else if (isForEquipMoves && equipModelRow && !equipModelRow?.getBoolean("driver1_active", false)) {
            this.addReason(reasonMap, "driver1_active", "Driver must be active to check feasibility.");
        }

        // Sync with split view panels, but only if not already in a sync operation
        if (!this.skipSyncUpdate && this.toolPanel.splitViewLayout != null) {
            let toolPanel: OrderPlanningToolPanel;
            if (isForOrderMoves && secondarySelected) {
                if (equipModelRow) {
                    toolPanel = this.toolPanel.splitViewLayout.getActiveEquipLayout().getToolsPanel();
                }
            } else if (isForEquipMoves) {
                if (ordersModelRow) {
                    toolPanel = this.toolPanel.splitViewLayout.layoutOrderPlanningOrders.getToolsPanel();
                }
            }
            const feasibilityAction = toolPanel?.getVisibleAction<RowActionFeasibility>(Tools.FEASIBILITY);
            if (feasibilityAction) {
                feasibilityAction.skipSyncUpdate = true;
                toolPanel.syncButtonState(feasibilityAction, null);
            }
        }
    }

    override execute(props: PlanningTableRowActionProps) {
        FeasibilitySlideout.slideUpForOrderPlanningToolPanel(this.toolPanel);
    }

    public getSelectedRowData(): { ordersRow: any, equipRow: any } {
        const ordersModelRow = this.toolPanel.splitViewLayout ? this.toolPanel.splitViewLayout.layoutOrderPlanningOrders.tableAvailableMoves.selectedRow?.data : null;
        const equipModelRow = this.toolPanel.splitViewLayout ? this.toolPanel.splitViewLayout.getActiveEquipLayout().getTable().selectedRow?.data : this.toolPanel.table.selectedRow?.data;
        return {
            ordersRow: ordersModelRow,
            equipRow: equipModelRow
        };
    }
}
